
export default [

        {
            path:'/dinghuo',
            name:'dinghuo',
            component:() => import('@/views/dinghuo/dinghuo'),
            meta: {
                keepAlive: true, //此组件需要被缓存
            }
        },
        {
            path:'/dinghuoList',
            name:'dinghuoList',
            component:() => import('@/views/dinghuo/dinghuoList')
        },
        {
            path:'/dinghuo_detail',
            name:'dinghuo_detail',
            component:() => import('@/views/dinghuo/dinghuo_detail')
        },
        
]


// WEBPACK FOOTER //
// ./src/router/dinghuo.js